const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
// @ components
const CardPaymentPurchaseDeferralStep = require('components/cards/cardPaymentPurchaseDeferral/cardPaymentPurchaseDeferralStep/cardPaymentPurchaseDeferralStep');
const CardPaymentPurchaseDeferralSliderSection = require('components/cards/cardPaymentPurchaseDeferral/cardPaymentPurchaseDeferralSliderSection/cardPaymentPurchaseDeferralSliderSection');
const { CardPaymentPurchaseDeferralSelectCreditCard } = require('components/cards/cardPaymentPurchaseDeferral/cardPaymentPurchaseDeferralSelectCreditCard/cardPaymentPurchaseDeferralSelectCreditCard');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ constants
const { CARD_PAYMENT_PURCHASE_DEFERRAL_ID } = require('constants/operationTypes');
const TRANSLATION_KEY_PREFIX = 'cardPaymentPurchaseDeferral-';
const { FIRST_STEP, SECOND_STEP } = require('constants/index');
const tagging = require('constants/tagging');
// @ helpers
const { nonNumericFilter } = require('utilities/stringHelper');
const { getChosenDeferralTag, isLavandaCard } = require('utilities/lavandaHelper');
const { getCardId } = require('utilities/commercialAdsHelper');

class CardPaymentPurchaseDeferral extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
    }

    componentWillMount(){
        const { immCard, lavandaEnabled, requestAds } = this.props;
        const commercialCardId = getCardId(immCard);

        lavandaEnabled ? requestAds([commercialCardId]) : null;
    }

    handleCancel() {
        const cardId = this.props.immCard.get('cardId');

        this.props.history.push(`/myprofile/cards/${cardId}/movements`);
    }

    buildWizard() {
        const {
            immCard,
            immCardPaymentPurchaseDeferral,
            immMovement,
            immGlobalVariables,
            setQuotaQuantity,
            setVisibleStep,
            setWillCancel,
            validateStep,
            onFinish
        } = this.props;

        const immSteps = immCardPaymentPurchaseDeferral.get('steps');

        const operationParams = {
            ammount: immMovement.getIn(['import', 'amount']),
            currency: immMovement.getIn(['import', 'currency']),
            pan: nonNumericFilter(immCard.get('number'))
        };

        const finalButtonText = TRANSLATION_KEY_PREFIX + 'finalButton';
        const stepOneTitleKey = TRANSLATION_KEY_PREFIX + 'stepOneTitle';
        const stepTwoTitleKey = TRANSLATION_KEY_PREFIX + 'stepTwoTitle';
        const stepTwoSubtitleKey = TRANSLATION_KEY_PREFIX + 'stepTwoSubtitle';

       const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            cancel: this.handleCancel,
            finish: onFinish
        };

        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immCardPaymentPurchaseDeferral.get('visibleStep')}
                wizardClass="card-payment-purchase-deferral__wizard"
                showPreLeaveModal={true}
            >
                <WizardStep position="first" cancelButton={true} nextButton={true} >
                    <CardPaymentPurchaseDeferralStep
                        immCard={immCard}
                        immCardPaymentPurchaseDeferral={immCardPaymentPurchaseDeferral}
                        immMovement={immMovement}
                        immGlobalVariables={immGlobalVariables}
                        quotaStep={FIRST_STEP}
                        titleKey={stepOneTitleKey}
                    >
                        <CardPaymentPurchaseDeferralSliderSection
                            immCard={immCard}
                            immCardPaymentPurchaseDeferral={immCardPaymentPurchaseDeferral}
                            setQuotaQuantity={setQuotaQuantity}
                            quotaStep={FIRST_STEP}
                        />
                    </CardPaymentPurchaseDeferralStep>
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour={true}
                    cancelButton={true}
                    finishButton={true}
                    immFinalButton={finalButtonText}
                    position="last"
                    previousButton={true}
                    isLoading={immCardPaymentPurchaseDeferral.get('isFetching')}

                >
                    <CardPaymentPurchaseDeferralStep
                        immCard={immCard}
                        immCardPaymentPurchaseDeferral={immCardPaymentPurchaseDeferral}
                        immMovement={immMovement}
                        immGlobalVariables={immGlobalVariables}
                        titleKey={stepTwoTitleKey}
                        quotaStep={FIRST_STEP}
                        subtitleKey={stepTwoSubtitleKey}
                        isLastStep={true}
                    >
                        <SignaturePattern
                            operationParams={operationParams}
                            operationType={CARD_PAYMENT_PURCHASE_DEFERRAL_ID}
                        />
                    </CardPaymentPurchaseDeferralStep>
                </WizardStep>
            </Wizard>
        );
    }

    buildWizardLavanda() {
        const {
            immCard,
            immCardPaymentPurchaseDeferral,
            immLavanda,
            immMovement,
            immGlobalVariables,
            lavandaEnabled,
            setDeferralOption,
            setQuotaQuantity,
            setVisibleStep,
            setWillCancel,
            threeMonthQuotaAmount,
            validateStep,
            onFinish
        } = this.props;

        const immSteps = immCardPaymentPurchaseDeferral.get('steps');

        const operationParams = {
            ammount: immMovement.getIn(['import', 'amount']),
            currency: immMovement.getIn(['import', 'currency']),
            pan: nonNumericFilter(immCard.get('number'))
        };

        const finalButtonText = TRANSLATION_KEY_PREFIX + 'finalButton';
        const stepOneTitleKey = TRANSLATION_KEY_PREFIX + 'stepOneTitle';
        const stepTwoTitleKey = TRANSLATION_KEY_PREFIX + 'stepTwoTitle';
        const stepTwoSubtitleKey = TRANSLATION_KEY_PREFIX + 'stepTwoSubtitle';
        const chosenDeferral = immSteps.getIn([1,'chosenDeferral']);
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            cancel: this.handleCancel,
            finish: onFinish
        };
        let content = <LoadingSection />;

        if (!lavandaEnabled || immLavanda.get('success')){
            const isLavanda = lavandaEnabled && !!immLavanda.get('cards') && isLavandaCard(immCard.get('product'), immLavanda.get('cards'));
            const numberQuotas = getChosenDeferralTag(immCardPaymentPurchaseDeferral.getIn(['steps', 1, 'installmentQuantity'], 0));
            const product = `${immCard.getIn(['product', 'type'])}.${immCard.getIn(['product', 'subtype'])}`;
            const processDetail = isLavanda && numberQuotas;
            let tealium = {};
            let tealiumEvents = {};

            if (isLavanda){
                tealium = {
                    processDetail: processDetail,
                    productName: product
                };
                tealiumEvents = {
                    cancel: {eventName: tagging.DEFERRAL_PAYMENT_CANCEL},
                    finish: {eventName: tagging.DEFERRAL_PAYMENT_FINISH, eventTag: processDetail},
                    next: {eventName: tagging.DEFERRAL_PAYMENT_NEXT, eventTag: immCardPaymentPurchaseDeferral.get('visibleStep') === 1 ? product : processDetail},
                    previous: {eventName: tagging.DEFERRAL_PAYMENT_PREVIOUS},
                };
            }

            content = (
                <Wizard
                    actions={actions}
                    immSteps={immSteps}
                    stepsAmount={immSteps.size}
                    visibleStep={immCardPaymentPurchaseDeferral.get('visibleStep')}
                    wizardClass="card-payment-purchase-deferral__wizard"
                    showPreLeaveModal={true}
                    tealium={tealium}
                    tealiumEvents={tealiumEvents}
                >
                    <WizardStep
                        cancelButton={true}
                        nextButton={true}
                        position="first"
                    >
                        <CardPaymentPurchaseDeferralSelectCreditCard
                            immCard={immCard}
                            lavandaEnabled={lavandaEnabled}
                        />
                    </WizardStep>
                    <WizardStep
                        cancelButton={true}
                        nextButton={true}
                        nextButtonDisabled={immCardPaymentPurchaseDeferral.getIn(['steps', 1, 'installmentQuantity'], 0) === 0 || immCardPaymentPurchaseDeferral.getIn(['steps', 1, 'isFetching'])}
                        position="middle"
                    >
                        <CardPaymentPurchaseDeferralStep
                            immCard={immCard}
                            immCardPaymentPurchaseDeferral={immCardPaymentPurchaseDeferral}
                            immLavanda={immLavanda}
                            immMovement={immMovement}
                            immGlobalVariables={immGlobalVariables}
                            lavandaEnabled={lavandaEnabled}
                            quotaStep={SECOND_STEP}
                            titleKey={stepOneTitleKey}
                            chosenDeferral={chosenDeferral}
                        >
                            <CardPaymentPurchaseDeferralSliderSection
                                immCard={immCard}
                                immCardPaymentPurchaseDeferral={immCardPaymentPurchaseDeferral}
                                immGlobalVariables={immGlobalVariables}
                                isLavandaCard={isLavanda}
                                lavandaEnabled={lavandaEnabled}
                                setQuotaQuantity={setQuotaQuantity}
                                quotaStep={SECOND_STEP}
                                totalFinanced={immMovement.get('import')}
                                setDeferralOption={setDeferralOption}
                                chosenDeferral={chosenDeferral}
                                threeMonthQuotaAmount={threeMonthQuotaAmount}
                            />
                        </CardPaymentPurchaseDeferralStep>
                    </WizardStep>
                    <WizardStep
                        addLoadingBehaviour={true}
                        cancelButton={true}
                        finishButton={true}
                        immFinalButton={finalButtonText}
                        position="last"
                        previousButton={true}
                        isLoading={immCardPaymentPurchaseDeferral.get('isFetching')}

                    >
                        <CardPaymentPurchaseDeferralStep
                            immCard={immCard}
                            immCardPaymentPurchaseDeferral={immCardPaymentPurchaseDeferral}
                            immLavanda={immLavanda}
                            immMovement={immMovement}
                            immGlobalVariables={immGlobalVariables}
                            lavandaEnabled={lavandaEnabled}
                            titleKey={stepTwoTitleKey}
                            quotaStep={SECOND_STEP}
                            subtitleKey={stepTwoSubtitleKey}
                            isLastStep={true}
                            chosenDeferral={chosenDeferral}
                        >
                            <SignaturePattern
                                operationParams={operationParams}
                                operationType={CARD_PAYMENT_PURCHASE_DEFERRAL_ID}
                            />
                        </CardPaymentPurchaseDeferralStep>
                    </WizardStep>
                </Wizard>
            );
        }

        return content;
    }

    render(){
        const { lavandaEnabled } = this.props;

        return lavandaEnabled ? this.buildWizardLavanda() : this.buildWizard();
    }
}

CardPaymentPurchaseDeferral.propTypes = {
    history: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    immCardPaymentPurchaseDeferral: PropTypes.object.isRequired,
    immLavanda: PropTypes.object.isRequired,
    immMovement: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object,
    lavandaEnabled: PropTypes.bool.isRequired,
    setDeferralOption: PropTypes.func,
    setQuotaQuantity: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    requestAds: PropTypes.func.isRequired,
    threeMonthQuotaAmount: PropTypes.object,
    validateStep: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired
};

module.exports = withRouter(CardPaymentPurchaseDeferral);
